/* ============================================================
   cs-collection.js   -   section: cs-collection
   Live filtering without a page reload.

   Every filter change builds the same URL a plain form submit would
   (Shopify's own filter.* params), fetches just this section through the
   Section Rendering API, and swaps the results in. The URL updates, so a
   filtered view can be shared or refreshed. With JS off, the form still
   works as a normal GET.
   ============================================================ */
(function () {
  function init(root) {
    if (root.dataset.csReady) return;
    root.dataset.csReady = '1';

    var sectionId = root.dataset.sectionId;
    var baseUrl = root.dataset.url;
    var form = root.querySelector('[data-cs-filter-form]');
    var openBtn = root.querySelector('[data-cs-open-filters]');
    var controller = null;
    var priceTimer = null;

    function paramsFromForm() {
      var fd = new FormData(form);
      var p = new URLSearchParams();
      fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      return p.toString();
    }

    function openState() {
      var open = {};
      root.querySelectorAll('[data-cs-filter]').forEach(function (d) { open[d.dataset.csFilter] = d.open; });
      return open;
    }

    function load(url, push) {
      /* grid views reached with ?view=... keep it, or Shopify serves the
         collection's default template (the tiles) instead of this grid */
      if (root.dataset.view) {
        var u = new URL(url, window.location.origin);
        if (!u.searchParams.has('view')) u.searchParams.set('view', root.dataset.view);
        url = u.pathname + u.search;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      var open = openState();
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

      root.classList.add('is-loading');
      fetch(fetchUrl, { signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-cs-results]', '[data-cs-filter-body]'].forEach(function (sel) {
            var next = doc.querySelector(sel);
            var cur = root.querySelector(sel);
            if (next && cur) cur.innerHTML = next.innerHTML;
          });
          /* keep whichever filter groups the shopper had open or closed */
          root.querySelectorAll('[data-cs-filter]').forEach(function (d) {
            if (open.hasOwnProperty(d.dataset.csFilter)) d.open = open[d.dataset.csFilter];
          });
          syncMeta();
          syncRange('init');
          if (push !== false) history.pushState({ csColl: true }, '', url);
        })
        .catch(function (e) {
          if (e.name !== 'AbortError') window.location.href = url;
        })
        .then(function () { root.classList.remove('is-loading'); });
    }

    function syncMeta() {
      var meta = root.querySelector('[data-cs-meta]');
      if (!meta) return;
      var n = meta.dataset.count, active = Number(meta.dataset.active || 0);
      var count = root.querySelector('[data-cs-count]');
      if (count) count.innerHTML = '<b>' + n + '</b> ' + (n === '1' ? 'item' : 'items');
      var inline = root.querySelector('[data-cs-count-inline]');
      if (inline) inline.textContent = n;
      var badge = root.querySelector('[data-cs-active-count]');
      if (badge) { badge.textContent = active; badge.hidden = active === 0; }
    }

    function submit() {
      var qs = paramsFromForm();
      load(baseUrl + (qs ? '?' + qs : ''));
    }

    /* ---------- price slider: two range inputs drive the two number fields ----------
       The slider moves through stops, not single dollars: $50 steps to $1,000,
       $100 to $3,000, $250 to $10,000, then $500. Fine control where most
       prices sit, without a twitchy handle on a $15k range. The number fields
       still accept any exact amount. */
    var stopsCache = null;
    function stopsFor(max) {
      if (stopsCache && stopsCache.max === max) return stopsCache.list;
      var list = [0], v = 0;
      while (v < max) {
        v += v < 1000 ? 50 : v < 3000 ? 100 : v < 10000 ? 250 : 500;
        list.push(Math.min(v, max));
      }
      stopsCache = { max: max, list: list };
      return list;
    }
    function nearest(list, price) {
      var best = 0;
      for (var i = 0; i < list.length; i++) { if (Math.abs(list[i] - price) < Math.abs(list[best] - price)) best = i; }
      return best;
    }
    function syncRange(from) {
      var r = root.querySelector('[data-cs-range]');
      if (!r) return;
      var max = Number(r.dataset.max) || 1;
      var stops = stopsFor(max), last = stops.length - 1;
      var a = r.querySelector('[data-cs-range-min]'), b = r.querySelector('[data-cs-range-max]');
      var lo = root.querySelector('[data-cs-price-min]'), hi = root.querySelector('[data-cs-price-max]');
      a.max = b.max = last; a.step = b.step = 1;
      if (from === 'number' || from === 'init') {
        a.value = lo.value === '' ? 0 : nearest(stops, Number(lo.value));
        b.value = hi.value === '' ? last : nearest(stops, Number(hi.value));
      }
      var ia = Number(a.value), ib = Number(b.value);
      if (ia > ib) { if (from === 'max') a.value = ia = ib; else b.value = ib = ia; }
      if (from === 'min' || from === 'max') {
        lo.value = stops[ia] > 0 ? stops[ia] : '';
        hi.value = ib < last ? stops[ib] : '';
      }
      r.style.setProperty('--a', (ia / last * 100) + '%');
      r.style.setProperty('--b', (ib / last * 100) + '%');
    }
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-cs-range-min]')) syncRange('min');
      else if (e.target.matches('[data-cs-range-max]')) syncRange('max');
      else if (e.target.matches('[data-cs-price-min], [data-cs-price-max]')) syncRange('number');
    });
    syncRange('init');

    form.addEventListener('change', function (e) {
      if (e.target.type === 'range') { submit(); return; }
      if (e.target.type === 'number') {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(submit, 500);
        return;
      }
      submit();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    /* sort lives outside the form element but belongs to it via form="" */
    var sort = root.querySelector('[data-cs-sort]');
    if (sort) sort.addEventListener('change', submit);

    /* ---------- custom sort menu over the hidden select ---------- */
    var sortUi = root.querySelector('[data-cs-sort-ui]');
    if (sortUi && sort) {
      var sBtn = sortUi.querySelector('[data-cs-sort-btn]');
      var sMenu = sortUi.querySelector('[data-cs-sort-menu]');
      var sScrim = sortUi.querySelector('[data-cs-sort-close]');
      var sLabel = sortUi.querySelector('[data-cs-sort-label]');
      var opts = Array.prototype.slice.call(sMenu.querySelectorAll('[role="option"]'));

      function openSort() {
        sMenu.hidden = false; sScrim.hidden = false;
        sortUi.classList.add('is-open'); sBtn.setAttribute('aria-expanded', 'true');
        var sel = sMenu.querySelector('[aria-selected="true"]') || opts[0];
        sel.focus();
      }
      function closeSort(refocus) {
        sortUi.classList.remove('is-open'); sBtn.setAttribute('aria-expanded', 'false');
        sMenu.hidden = true; sScrim.hidden = true;
        if (refocus) sBtn.focus();
      }
      function pick(li) {
        opts.forEach(function (o) { o.setAttribute('aria-selected', o === li ? 'true' : 'false'); });
        sLabel.textContent = li.textContent.trim();
        closeSort(true);
        if (sort.value !== li.dataset.value) {
          sort.value = li.dataset.value;
          sort.dispatchEvent(new Event('change'));
        }
      }
      sBtn.addEventListener('click', function () { sortUi.classList.contains('is-open') ? closeSort(true) : openSort(); });
      sScrim.addEventListener('click', function () { closeSort(true); });
      sMenu.addEventListener('click', function (e) { var li = e.target.closest('[role="option"]'); if (li) pick(li); });
      sMenu.addEventListener('keydown', function (e) {
        var i = opts.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); opts[Math.min(opts.length - 1, i + 1)].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); opts[Math.max(0, i - 1)].focus(); }
        else if (e.key === 'Home') { e.preventDefault(); opts[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); opts[opts.length - 1].focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i > -1) pick(opts[i]); }
        else if (e.key === 'Escape' || e.key === 'Tab') { closeSort(e.key === 'Escape'); }
      });
      document.addEventListener('click', function (e) {
        if (sortUi.classList.contains('is-open') && !sortUi.contains(e.target)) closeSort(false);
      });
    }

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-cs-link], [data-cs-clear]');
      if (link && link.href) {
        e.preventDefault();
        load(link.href);
        if (link.closest('.cs-pages')) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (e.target.closest('[data-cs-open-filters]')) setOpen(true);
      if (e.target.closest('[data-cs-close-filters]')) setOpen(false);
    });

    function setOpen(on) {
      root.classList.toggle('is-filtering', on);
      if (openBtn) openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.documentElement.style.overflow = on ? 'hidden' : '';
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-filtering')) setOpen(false);
    });

    window.addEventListener('popstate', function () { load(window.location.href, false); });
  }

  function boot() { document.querySelectorAll('[data-cs-collection]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
